import { render, staticRenderFns } from "./kdxGoodsDetailInfo.g.vue?vue&type=template&id=35af7b53&scoped=true"
import script from "./kdxGoodsDetailInfo.g.vue?vue&type=script&lang=js"
export * from "./kdxGoodsDetailInfo.g.vue?vue&type=script&lang=js"
import style0 from "./kdxGoodsDetailInfo.g.vue?vue&type=style&index=0&id=35af7b53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35af7b53",
  null
  
)

export default component.exports